import { useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../components/Breadcrumb";
import Students from "./Students";
import Classes from "./Classes";
import Teachers from "./Teachers";

const renderTab = (tabToRender, id) => {
  switch (tabToRender) {
    case "teachers":
      return <Teachers />;
    case "classes":
    default:
      return id ? <Students classId={id} /> : <Classes />;
  }
};

function Accounts() {
  const { id } = useParams();
  let { pathname: url } = useLocation();
  let newUrl = url.split("/");
  newUrl.shift();
  newUrl.shift();
  return (
    <>
      <Breadcrumb />
      {renderTab(newUrl[0], newUrl[1], id)}
    </>
  );
}

export default Accounts;
